import React from "react";

interface ShapeIconProps {
  width?: string;
  height?: string;
  fill?: string;
}

const ShapeIcon: React.FC<ShapeIconProps> = ({
  width = "14",
  height = "14",
  fill = "#731DCF",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.83301 1.16666C7.83301 0.706424 7.45991 0.333328 6.99967 0.333328C6.53944 0.333328 6.16634 0.706424 6.16634 1.16666V6.16666H1.16634C0.706104 6.16666 0.333008 6.53976 0.333008 6.99999C0.333008 7.46023 0.706104 7.83333 1.16634 7.83333H6.16634V12.8333C6.16634 13.2936 6.53944 13.6667 6.99967 13.6667C7.45991 13.6667 7.83301 13.2936 7.83301 12.8333V7.83333H12.833C13.2932 7.83333 13.6663 7.46023 13.6663 6.99999C13.6663 6.53976 13.2932 6.16666 12.833 6.16666H7.83301V1.16666Z"
        fill={fill}
      />
    </svg>
  );
};

export default ShapeIcon;
